

import { fromJS } from 'immutable';

const hasBootstrapData = () => !!window.BOOTSTRAP_DATA;
const hasSharedMediaCss = () => !!window.SHARED_MEDIA_CSS;
const hasPreferredValues = () => !!window.BOOTSTRAP_DATA.preferredValues;

export const getEnv = () => {
    if (hasBootstrapData()) {
        return window.BOOTSTRAP_DATA.ENVIRONMENT;
    }
    return null;
};

export const getIsDesktop = () => {
    if (hasBootstrapData()) {
        return window.BOOTSTRAP_DATA.isDesktop;
    }
    return false;
};

export const getCapiUrl = () => {
    if (hasBootstrapData()) {
        return window.BOOTSTRAP_DATA.capiUrl;
    }
    return null;
};

export const getOrderingToken = () => {
    if (hasBootstrapData()) {
        return window.BOOTSTRAP_DATA.brand.orderingToken;
    }
    return null;
};

export const getSegmentKey = () => {
    try {
        
        return window.BOOTSTRAP_DATA.brand.iapetus;
    } catch (e) {
        return null;
    }
};

export const getBrandCode = () => {
    if (hasBootstrapData()) {
        return window.BOOTSTRAP_DATA.brand.brandCode;
    }
    return null;
};

export const getDefaultLocaleCode = () => {
    if (hasBootstrapData()) {
        return window.BOOTSTRAP_DATA.brand.defaultLocaleCode;
    }
    return null;
};

export const getPreferredLocaleCode = () => {
    if (hasBootstrapData()) {
        return window.BOOTSTRAP_DATA.brand.preferredLocaleCode;
    }
    return null;
};

export const getBrandData = () => window.BOOTSTRAP_DATA.brand;

export const getFeatureFlags = () => {
    if (hasBootstrapData()) {
        return fromJS(window.BOOTSTRAP_DATA.featureFlags);
    }
    return null;
};

export const getMasterpassData = () => {
    if (hasBootstrapData()) {
        return fromJS(window.BOOTSTRAP_DATA.MASTERPASS);
    }
    return fromJS({});
};


export const getStaticMediaURL = (suffix) => {
    if (!hasBootstrapData()) {
        return null;
    }

    let url = window.BOOTSTRAP_DATA.staticMediaUrl;
    url = url.replace(/\/$/, '');

    if (suffix) {
        url += suffix;
    }
    return url;
};

export const getSharedMediaCssUrl = () => {
    if (!hasSharedMediaCss()) {
        return '';
    }
    return window.SHARED_MEDIA_CSS;
};

export const getPreferredValues = () => window.BOOTSTRAP_DATA.preferredValues;




export const getPreferredPromoCode = () => {
    if (hasPreferredValues()) {
        return getPreferredValues().promoCode;
    }
    return null;
};
